import styled from 'particles/themes/styled'

export const ReportHeader = styled.div`
    position: sticky;
    top: 0;
    z-index: 99;
`

export const ReportContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[300]};
    padding-bottom: 8px;
    background: ${({ theme }) => theme.colors.background.primary};

    .brand-logo {
        width: 48px;
        height: 48px;
        border-radius: 7px;
    }

    .campaign-info {
        display: flex;
        flex-direction: column;
    }
`

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: fit-content;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    align-self: stretch;
    background-color: ${({ theme }) => theme.colors.background.primary};
    overflow-y: auto;

    .title-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        align-items: flex-start;
        align-self: stretch;
    }
`

export const NavbarWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .tab {
        padding-bottom: 16px;
        background: ${({ theme }) => theme.colors.background.primary};
    }
`
